<div class="bg-beige grow">
  <section class="profile-income">
    @if (isLoading$ | async) {
      <div
        class="flex-centered spinner-container"
        >
        <mat-spinner diameter="60"></mat-spinner>
      </div>
    } @else {
      @if (error$ | async) {
        <app-notification variant="error">
          <p class="be-body-s text-navy-800 mb-4">
            Error occurred while looking up income data.
          </p>
        </app-notification>
      }
      @if (!(error$ | async) && incomeData$ | async; as incomeData) {
        <div class="be-card">
          @if (!isEditMode) {
            <app-profile-details
              [entries]="incomeDataDlEntries"
              (onEdit)="toggleIsEditMode()"
              [modalData]="modalData"
            ></app-profile-details>
          }
          @if (isEditMode) {
            <app-gross-income-edit-mode
              [incomeForm]="incomeForm"
              [employmentStatusOptions]="employmentStatusOptions"
              [isNullField]="isNullField"
              (onCancel)="toggleIsEditMode()"
            ></app-gross-income-edit-mode>
          }
        </div>
      }
    }

  </section>
</div>
